import { useState } from 'react';
import clsx from 'clsx';
import type { Project } from '@/api/client';
import { useAuth } from '@/contexts/useAuth';
import { FonotekaProjectPicker } from './FonotekaProjectPicker';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import './fonoteka.css';

export type FonotekaProjectCellProps = {
  project: Project;
  disabled?: boolean;
};

export function FonotekaProjectCell({ project, disabled = false }: FonotekaProjectCellProps) {
  const { capabilities } = useAuth();
  const [open, setOpen] = useState(false);

  if (!capabilities.fonoteka.read) return null;

  const count = project.fonoteka_track_count ?? 0;
  const canWrite = capabilities.fonoteka.write && capabilities.projects.write && !disabled;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={clsx(
            'projects-table__status-btn',
            'projects-table__status-btn_wide',
            count > 0 ? 'projects-table__status-btn_blue' : 'projects-table__status-btn_outline',
          )}
          disabled={disabled}
          title="Фонотека"
          aria-label={count > 0 ? `Фонотека: ${count}` : 'Фонотека'}
          aria-haspopup="dialog"
          aria-expanded={open}
          onClick={(e) => e.stopPropagation()}
        >
          Фонотека
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        side="bottom"
        collisionPadding={16}
        className="z-[1100] w-[32rem] max-w-[min(32rem,calc(100vw-1.5rem))] p-0"
        onClick={(e) => e.stopPropagation()}
        onPointerDown={(e) => e.stopPropagation()}
      >
        <FonotekaProjectPicker
          projectId={project.id}
          projectName={project.name}
          open={open}
          canWrite={canWrite}
          onClose={() => setOpen(false)}
        />
      </PopoverContent>
    </Popover>
  );
}
